module.exports = __webpack_public_path__ + "static/media/technical.627ff29b.jpg";